import type { FC } from 'react'
import { FeedbackDropdown, type FeedbackDropdownProps } from '#features/Feedback/FeedbackDropdown'
import { useInjectedReportDataCollector } from '#features/Feedback/injectReportDataFields'

export const ConfigurationFeedbackDropdown: FC<FeedbackDropdownProps> = (props) => {
  useInjectedReportDataCollector()
  return <FeedbackDropdown {...props} />
}
